import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    checkRedeemCode, 
    activateRedeemedSubscription, 
    activateDiscountCode,
    checkAccessPass,
    activateAccessPass
} from '../services/api';

const RedeemPage = () => {
    const navigate = useNavigate();
    const [redeemCode, setRedeemCode] = useState('');
    const [discountCode, setDiscountCode] = useState('');
    const [planDetails, setPlanDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [accessPassCode, setAccessPassCode] = useState('');
    const [accessPassInfo, setAccessPassInfo] = useState(null);

    const handleCheckCode = async (e) => {
        e.preventDefault();
        if (!redeemCode) {
            setError('請輸入您的兌換碼。');
            return;
        }
        setLoading(true);
        setError('');
        setPlanDetails(null);
        try {
            const response = await checkRedeemCode(redeemCode);
            setPlanDetails(response.data.data);
        } catch (err) {
            setError(err.response?.data?.message || '查詢失敗，請檢查您的兌換碼是否正確。');
        } finally {
            setLoading(false);
        }
    };

    const handleActivate = async () => {
        if (!planDetails) return;
        setLoading(true);
        setError('');
        try {
            await activateRedeemedSubscription({
                subscriptionPlanId: planDetails.redeemSubscriptionPlanId,
                redeemCode: redeemCode
            });
            alert('方案已成功啟用！');
            navigate('/subscriptions');
        } catch (err) {
            setError(err.response?.data?.message || '啟用失敗，請稍後再試。');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container">
            <div className="page-header">
                <h2>兌換方案</h2>
            </div>

            {/* 【修改處】使用新的左右佈局容器 */}
            <div className="redeem-container">
                {/* 左側：輸入表單 */}
                <div className="redeem-form-section">
                    <h4>輸入兌換碼</h4>
                    <form onSubmit={handleCheckCode} className="redeem-form">
                        <p>請在此輸入您收到的兌換碼，並點擊查詢以檢視方案內容。</p>
                        <div className="input-group">
                            <input
                                type="text"
                                id="redeemCode"
                                value={redeemCode}
                                onChange={(e) => setRedeemCode(e.target.value)}
                                placeholder="輸入兌換碼"
                                disabled={loading}
                            />
                            <button type="submit" disabled={loading && !planDetails} className="action-button default">
                                {loading ? '查詢中...' : '查詢'}
                            </button>
                        </div>
                    </form>

                    <h4 style={{ marginTop: '2rem' }}>輸入通行證 Access Pass</h4>
                    <form onSubmit={async (e) => {
                        e.preventDefault();
                        if (!accessPassCode) return;
                        setLoading(true);
                        setError('');
                        setAccessPassInfo(null);
                        try {
                            const resp = await checkAccessPass(accessPassCode);
                            setAccessPassInfo(resp.data.data);
                        } catch (err) {
                            setError(err.response?.data?.message || '查詢失敗，請檢查您的通行證代碼是否正確。');
                        } finally {
                            setLoading(false);
                        }
                    }} className="redeem-form">
                        <p>輸入通行證代碼，查詢可切換的多個方案以及有效天數。</p>
                        <div className="input-group">
                            <input
                                type="text"
                                id="accessPassCode"
                                value={accessPassCode}
                                onChange={(e) => setAccessPassCode(e.target.value)}
                                placeholder="輸入通行證代碼"
                                disabled={loading}
                            />
                            <button type="submit" disabled={loading} className="action-button default">
                                {loading ? '查詢中...' : '查詢通行證'}
                            </button>
                        </div>
                    </form>

                    {accessPassInfo && (
                        <button onClick={async () => {
                            if (!accessPassCode) return;
                            setLoading(true);
                            setError('');
                            try {
                                await activateAccessPass(accessPassCode);
                                alert('通行證已啟用！在有效期間內切換指定方案將完全免費。');
                                setAccessPassCode('');
                                setAccessPassInfo(null);
                                navigate('/subscriptions');
                            } catch (err) {
                                setError(err.response?.data?.message || '啟用失敗，請稍後再試。');
                            } finally {
                                setLoading(false);
                            }
                        }} disabled={loading} className="action-button resume" style={{marginTop: '1rem'}}>
                            {loading ? '啟用中...' : '啟用通行證'}
                        </button>
                    )}

                    <h4 style={{ marginTop: '2rem' }}>輸入折扣碼</h4>
                    <form onSubmit={async (e) => {
                        e.preventDefault();
                        if (!discountCode) return;
                        setLoading(true);
                        setError('');
                        try {
                            await activateDiscountCode(discountCode);
                            alert('折扣碼已啟用！之後期間內的訂閱與續訂將自動套用折扣。');
                            setDiscountCode('');
                        } catch (err) {
                            setError(err.response?.data?.message || '折扣碼啟用失敗');
                        } finally {
                            setLoading(false);
                        }
                    }} className="redeem-form">
                        <p>折扣碼會從啟用當下起算有效期限，期間內的訂閱與續訂自動折扣。</p>
                        <div className="input-group">
                            <input
                                type="text"
                                id="discountCode"
                                value={discountCode}
                                onChange={(e) => setDiscountCode(e.target.value)}
                                placeholder="輸入折扣碼"
                                disabled={loading}
                            />
                            <button type="submit" disabled={loading} className="action-button default">
                                {loading ? '啟用中...' : '啟用折扣碼'}
                            </button>
                        </div>
                    </form>
                </div>

                {/* 右側：顯示結果 */}
                <div className="redeem-details-section">
                    <h4>可兌換內容</h4>
                    {loading && <p>查詢中...</p>}
                    {error && <p className="error-message">{error}</p>}
                    
                    {!loading && !error && !planDetails && (
                        <div className="placeholder-box">
                            <p>查無兌換方案</p>
                        </div>
                    )}
                    
                    {!loading && !error && planDetails && (
                        <div className="plan-details-box">
                            <ul className="plan-info-list">
                                <li><strong>方案名稱:</strong> {planDetails.redeemSubscriptionName}</li>
                                <li><strong>試用天數:</strong> {planDetails.trialDurationDays} 天</li>
                                <li><strong>支援儲值:</strong> {planDetails.deposit ? '是' : '否'}</li>
                            </ul>
                            
                            {planDetails.metadata && Object.keys(planDetails.metadata).length > 0 && (
                                <>
                                    <hr className="details-divider" />
                                    <h5>方案權限</h5>
                                    <ul className="metadata-list">
                                        {Object.entries(planDetails.metadata).map(([key, value]) => (
                                            <li key={key}>
                                                <strong>{key}:</strong> {String(value)}
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            )}
                            <button onClick={handleActivate} disabled={loading} className="action-button resume" style={{marginTop: '1.5rem', width: '100%'}}>
                                {loading ? '啟用中...' : '確認啟用此方案'}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RedeemPage;